import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mediaFile: {
        objectFit: "cover",
        width: "100%",
        height: "306px",
    },
    mediaLegend: {
        margin: 0,
        fontSize: "12.5px",
        fontFamily: "Source Sans 3",
        color: theme.palette.primary.darker,
    },
    mediaLink: {
        textDecoration: "none",
        position: "relative",
        "&:hover $deleteIcon": {
            display: "block",
        },
    },
    deleteIcon: {
        position: "absolute",
        top: "5px",
        right: "5px",
        display: "none",
        cursor: "pointer",
        zIndex: 1,
        color: theme.palette.error.main,
        backgroundColor: "white",
        borderRadius: "4px",
    },
}));
